/**
 * <NeoPayProofLink url="..." transferId="..." />
 *
 * iter197 — Universal chain-icon. If we have a `transferId`, link to our
 * internal Authenticity Certificate page (preferred). Otherwise fall back
 * to the external NeoPay proof URL (for fund_txn / member_joined / etc.
 * events that aren't backed by a coin_transfers row).
 *
 * Renders nothing when neither is available — safe to drop next to any
 * row that *may* have a mirror stamp.
 */
import { Link as RouterLink } from 'react-router-dom';
import { Link2 } from 'lucide-react';

export default function NeoPayProofLink({
  url,
  transferId,
  size = 'sm',
  label = 'View on NeoPay',
  testId,
  className = '',
}) {
  if (!url && !transferId) return null;
  const cls = size === 'xs'
    ? 'w-5 h-5 text-xs'
    : size === 'md'
      ? 'w-7 h-7'
      : 'w-6 h-6';
  const iconCls = size === 'xs' ? 'w-2.5 h-2.5' : 'w-3 h-3';
  const stop = (e) => e.stopPropagation();
  const baseCls = `shrink-0 inline-flex items-center justify-center rounded-full bg-violet-500/10 hover:bg-violet-500/20 text-violet-600 dark:text-violet-300 border border-violet-500/30 transition-colors ${cls} ${className}`;

  if (transferId) {
    return (
      <RouterLink
        to={`/proof/${transferId}`}
        onClick={stop}
        title="View Authenticity Certificate"
        aria-label="View Authenticity Certificate"
        data-testid={testId || 'neopay-proof-link'}
        className={baseCls}
      >
        <Link2 className={iconCls} strokeWidth={2.5} />
      </RouterLink>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={stop}
      title={label}
      aria-label={label}
      data-testid={testId || 'neopay-proof-link'}
      className={baseCls}
    >
      <Link2 className={iconCls} strokeWidth={2.5} />
    </a>
  );
}
